import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
function SourceLabelWithInstanceLink({
  label,
  instance,
  shouldTruncate = true,
  linkTabIndex = 0
}) {
  const hasInstanceLink = instance === null || instance === void 0 ? void 0 : instance.relativeUri;
  return hasInstanceLink ? /*#__PURE__*/_jsx(Link, {
    "data-test-id": "source-label-with-instance-link",
    href: `${window.location.origin}/${instance.relativeUri}`,
    truncate: shouldTruncate,
    external: true,
    iconProps: {
      size: '300',
      color: 'icon-core-subtle'
    },
    tabIndex: linkTabIndex,
    children: label
  }) : /*#__PURE__*/_jsx(View, {
    as: "span",
    "data-test-id": "source-label",
    children: shouldTruncate ? /*#__PURE__*/_jsx(TruncateString, {
      tooltip: label,
      children: label
    }) : /*#__PURE__*/_jsx(Text, {
      as: "span",
      children: label
    })
  });
}
export default SourceLabelWithInstanceLink;